module.exports = __webpack_public_path__ + "img/thumb_34.68aad396.jpg";